import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Empty } from 'antd'
import { ReactComponent as IconAsc } from "../../../assets/icon/icon-asc.svg"
import { ReactComponent as IconDesc } from "../../../assets/icon/icon-desc.svg"
const filterProductType = (data, isSilk = false, isEmbroidery = false) => {
    if (!isSilk && !isEmbroidery) return data

    const { items = [] } = data

    const calculated = {
        overtime: 0,
        total: 0,
        total_with_note: 0,
        overtime_with_note: 0,
        total_no_note: 0,
        overtime_no_note: 0,
    }

    const filteredItems = []
    items.forEach(item => {
        const { categories = [] } = Object.assign({}, item)
        const isFilter = (isEmbroidery && isSilk) ?
            (categories.includes('embroidery') || categories.includes('silk') || categories.includes('pyjama')) :
            isEmbroidery ? categories.includes('embroidery') : isSilk ? (categories.includes('silk') || categories.includes('pyjama')) : false

        if (isFilter) {
            filteredItems.push(item)
            calculated.overtime += item.overtime || 0
            calculated.total += item.total || 0
            calculated.total_with_note += item.total_with_note || 0
            calculated.overtime_with_note += item.overtime_with_note || 0
            calculated.total_no_note += item.total_no_note || 0
            calculated.overtime_no_note += item.overtime_no_note || 0
        }
    })

    return {
        ...calculated,
        items: filteredItems
    }
}

class StaticsTableCutoff extends Component {
    _sortArray = (data, key, desc) => {
        return data.sort((a, b) => {
            if (!desc) {
                return a[key] - b[key]
            } else {
                return b[key] - a[key]
            }
        })
    }

    render() {
        const { data = {}, error, silkFilter = false, embroideryFilter = false, sortData, onSortData } = this.props
        const { items = [], overtime, total, total_with_note, overtime_with_note, total_no_note, overtime_no_note } = filterProductType(data || {}, silkFilter, embroideryFilter)
        const { sort, desc } = sortData
        const getPercent = (value) => {
            if (!Number.isInteger(value * 100)) {
                return (value * 100).toFixed(2) + '%'
            } else {
                return value * 100 + '%'
            }
        }

        const newItems = this._sortArray(items, sort, desc)

        return (
            <div className="StaticsTableCutoff">
                {
                    !!error && error.length > 0 &&
                    <label className='text-danger w-100 text-left'>{error}</label>
                }
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th className='text-left'>SKU</th>
                            <th onClick={() => onSortData('total', !desc)}>
                                Tổng items cần sản xuất
                                <span className={`Sort ${sort === 'total' ? 'active' : ''} ${desc}`}>
                                    <IconAsc />
                                    <IconDesc />
                                </span>
                            </th>
                            <th onClick={() => onSortData('total_no_note', !desc)}>
                                Items cần sản xuất (No note)
                                <span className={`Sort ${sort === 'total_no_note' ? 'active' : ''} ${desc}`}>
                                    <IconAsc />
                                    <IconDesc />
                                </span>
                            </th>
                            <th onClick={() => onSortData('total_with_note', !desc)}>
                                Items cần sản xuất (Has note)
                                <span className={`Sort ${sort === 'total_with_note' ? 'active' : ''} ${desc}`}>
                                    <IconAsc />
                                    <IconDesc />
                                </span>
                            </th>
                            <th onClick={() => onSortData('overtime', !desc)}>
                                Tổng items quá hạn
                                <span className={`Sort ${sort === 'overtime' ? 'active' : ''} ${desc}`}>
                                    <IconAsc />
                                    <IconDesc />
                                </span>
                            </th>
                            <th onClick={() => onSortData('overtime_no_note', !desc)}>
                                Quá hạn (No note)
                                <span className={`Sort ${sort === 'overtime_no_note' ? 'active' : ''} ${desc}`}>
                                    <IconAsc />
                                    <IconDesc />
                                </span>
                            </th>
                            <th onClick={() => onSortData('overtime_with_note', !desc)}>
                                Quá hạn (Has note)
                                <span className={`Sort ${sort === 'overtime_with_note' ? 'active' : ''} ${desc}`}>
                                    <IconAsc />
                                    <IconDesc />
                                </span>
                            </th>
                            <th onClick={() => onSortData('overtime_rate', !desc)}>
                                Tỉ lệ quá hạn (%)
                                <span className={`Sort ${sort === 'overtime_rate' ? 'active' : ''} ${desc}`}>
                                    <IconAsc />
                                    <IconDesc />
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {newItems.length > 0 && <tr>
                            <td className='text-left font-weight-bold'>Total</td>
                            <td className='font-weight-bold'>{total || 0}</td>
                            <td className='font-weight-bold'>{total_no_note || 0}</td>
                            <td className='font-weight-bold'>{total_with_note || 0}</td>
                            <td className='font-weight-bold'>{overtime || 0}</td>
                            <td className='font-weight-bold'>{overtime_no_note || 0}</td>
                            <td className='font-weight-bold'>{overtime_with_note || 0}</td>
                            <td></td>
                        </tr>}
                        {
                            !!newItems.length ? newItems.map((item, index) =>
                                <tr key={index}>
                                    <td className='SKU text-left'>{item.type}</td>
                                    <td>{item.total || 0}</td>
                                    <td>{item.total_no_note || 0}</td>
                                    <td>{item.total_with_note || 0}</td>
                                    <td>{item.overtime || 0}</td>
                                    <td>{item.overtime_no_note || 0}</td>
                                    <td>{item.overtime_with_note || 0}</td>
                                    <td>{getPercent(item.overtime_rate) || 0}</td>
                                </tr>
                            ) :
                                <tr>
                                    <td colSpan={8}><Empty description='No data' /></td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
        )
    }
}

StaticsTableCutoff.propTypes = {
    data: PropTypes.any.isRequired,
    loading: PropTypes.any,
    error: PropTypes.string
}

export default StaticsTableCutoff
